import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
var AlertDetailsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AlertDetailsModalComponent, _super);
    function AlertDetailsModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AlertDetailsModalComponent;
}(UiModalComponent));
export { AlertDetailsModalComponent };
